import { VouchersAction, VouchersState } from './type';
import { VouchersActionsNames } from './vouchers.actions';

const initialState: VouchersState = {
  isLoading: false,
  error: null,
  vouchers: [],
};

const vouchersReducer = (
  state: VouchersState = initialState,
  action: VouchersAction
): VouchersState => {
  switch (action.type) {
    case VouchersActionsNames.GET_VOUCHERS.START:
      return { ...state, isLoading: true, error: null };
    case VouchersActionsNames.GET_VOUCHERS.FULFILLED:
      return { ...state, isLoading: false, vouchers: action.payload };
    case VouchersActionsNames.GET_VOUCHERS.REJECTED:
      return { ...state, isLoading: false, error: action.payload };

    case VouchersActionsNames.GET_VOUCHER.START:
      return { ...state, isLoading: true, error: null };
    case VouchersActionsNames.GET_VOUCHER.FULFILLED:
      return { ...state, isLoading: false };
    case VouchersActionsNames.GET_VOUCHER.REJECTED:
      return { ...state, isLoading: false, error: action.payload };

    case VouchersActionsNames.ADD_VOUCHERS.START:
      return { ...state, isLoading: true, error: null };
    case VouchersActionsNames.ADD_VOUCHERS.FULFILLED:
      return { ...state, isLoading: false };
    case VouchersActionsNames.ADD_VOUCHERS.REJECTED:
      return { ...state, isLoading: false, error: action.payload };

    case VouchersActionsNames.UPDATE_VOUCHER.START:
      return { ...state, isLoading: true, error: null };
    case VouchersActionsNames.UPDATE_VOUCHER.FULFILLED:
      return { ...state, isLoading: false };
    case VouchersActionsNames.UPDATE_VOUCHER.REJECTED:
      return { ...state, isLoading: false, error: action.payload };

    default:
      return state;
  }
};

export default vouchersReducer;
